import React from 'react';

import logoRediseg from '../images/logo_rediseg.svg';

import RetinaImage from 'react-retina-image';

import 'sweetalert2/dist/sweetalert2.min.css';
import './ModalBuscaCameras/style.css';

const Footer = () => (
    <div style={{ zIndex: 1, padding: 20 }}>
        <div style={{ float: "right" }}>
        Powered by <RetinaImage className="logo" width={100} src={logoRediseg} />
        </div>
    </div>
)

export default (Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js